var myScroll = new IScroll('.scroll-wrapper', {
  scrollX: true,
  scrollY: false,
  scrollbars: 'custom',
  mousewheel: false,
  deceleration: .0075,
  shrinkScrollbars: 'clip',
  scrollbars: true,
  interactiveScrollbars: true,
  eventPassthrough: true,
  listenX: true,
});

setTimeout(function(){
  myScroll.refresh();
}, 1500);